import clsx from 'clsx';
import React, { ReactElement } from 'react';
import {
  makeElementClassNameFactory,
  makeRootClassName,
  StyleProps,
} from '@/utils';
import { Link } from '@/components';
import { Question } from '@/features/glossary-page/types';
import { slugifyTitle } from '@/utils/slugifyTitle';

type SideNavItem = {
  name: string;
  label: string;
  subItems?: Question[];
};

export type SideNavProps = StyleProps & {
  selected?: string | null;
  options: SideNavItem[];
};

const ROOT = makeRootClassName('SideNav');
const el = makeElementClassNameFactory(ROOT);

const DEFAULT_PROPS = {} as const;

function SideNav(props: SideNavProps): ReactElement {
  const p = { ...DEFAULT_PROPS, ...props };
  return (
    <div className={clsx(ROOT, p.className)}>
      <ul className={el`nav`}>
        {p.options.map(({ name, label, subItems }) => {
          const isActive =
            name === p.selected ||
            subItems?.find(({ title }) => slugifyTitle(title) === p.selected);

          return (
            <li className={el`nav-item`} key={name}>
              <Link
                className={clsx(el`link`, {
                  'is-active': isActive,
                })}
                href={`#${name}`}
                variant="white"
              >
                {label}
              </Link>
              {subItems?.map(({ title }) => (
                <div className={el`nav-sub-item`} key={title}>
                  <a href={`#${slugifyTitle(title)}`}>{title}</a>
                </div>
              ))}
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default SideNav;
